import { render, staticRenderFns } from "./AttendeeRegistration.vue?vue&type=template&id=4279dcb8&scoped=true&"
import script from "./AttendeeRegistration.vue?vue&type=script&lang=js&"
export * from "./AttendeeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeRegistration.vue?vue&type=style&index=0&id=4279dcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279dcb8",
  null
  
)

export default component.exports